import { render, staticRenderFns } from "./articleType.vue?vue&type=template&id=15e02b0a&scoped=true&"
import script from "./articleType.vue?vue&type=script&lang=js&"
export * from "./articleType.vue?vue&type=script&lang=js&"
import style0 from "./articleType.vue?vue&type=style&index=0&id=15e02b0a&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e02b0a",
  null
  
)

component.options.__file = "articleType.vue"
export default component.exports